import Stack from '@admin/components/stack'
import Translating from './translating'
import Completed from './completed'
import PropTypes from 'prop-types'
import Details from './details'
import React from 'react'

class Translate extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    entity_type: PropTypes.string,
    entity_id: PropTypes.number
  }

  stackRef = React.createRef()

  _handleCompleted = this._handleCompleted.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleTranslating = this._handleTranslating.bind(this)

  render() {
    return <Stack { ...this._getStack()} />
  }

  componentDidMount() {
    this._handleDetails()
  }

  _getStack() {
    return {
      display_name: 'translator',
      ref: this.stackRef
    }
  }

  _handleDone(social_campaign) {
    this.context.modal.close()
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleCompleted() {
    this._handlePush(Completed, {
      onDone: this._handleDone
    })
  }

  _handleDetails() {
    this._handlePush(Details, {
      ...this.props,
      onCancel: this._handleCancel,
      onDone: this._handleTranslating
    })
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

  _handleTranslating() {
    this._handlePush(Translating, {
      ...this.props,
      onDone: this._handleCompleted
    })
  }

}

export default Translate

